import React, { useContext, useState } from "react";
import {
  Form,
  Input,
} from "reactstrap";
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import { toast } from "react-toastify";
import validator from "validator";
import Axios from "axios";
import { Redirect, Link } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
const Test4 = () => {
  const context = useContext(UserContext);

  const [email, setEmail] = useState(context.user?.otpemail);
  console.log(setEmail)
  const [otp, setOtp] = useState("");
  // const [password,setPassword]=useState('')
  const logindata = {
    email: "", otp: "",
  };
  if (context.user === null) {
    toast.error("Seems that you have refresh Page,try again", {
      position: toast.POSITION.BOTTOM_LEFT,
    });
  }
  const handleFormSubmit = (e) => {
    e.preventDefault();
    verifyotp();
  };
  const verifyotp = async () => {
    if (otp === "") {
      toast.error("Otp is Empty", { position: toast.POSITION.BOTTOM_LEFT });
      return;
    } else if (!validator.isNumeric(otp)) {
      toast.error("Please Enter valid OTP", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    logindata.email = email;
    logindata.otp = otp;
    await Axios.post("Login/checkotp", { logindata })
      .then((res) => {
        if (res.data.status === "200" && res.data.msg === "true") {
          toast.success("Otp match successfully!!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          context.setUser({ otp: res.data.status, otpemail: email })
          return res;
        } else if (res.data.status === "200" && res.data.msg === "false") {
          toast.error("Otp did not match!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          setOtp("");
          return res;
        } else if (res.data.status === "200" && res.data.msg === "expired") {
          toast.error("Otp Expired.!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          return res;
        } else {
          toast.error("Something went wrong", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        }
        throw res;
      })
      .then((resJson) => { })
      .catch((error) => {
        console.log("error123", error);
      });

  };
  if (context.user?.otp) {
    return <Redirect to="/Registration" />
  }
  else if (context.user === null) {
    return <Redirect to="/Signup" />
  }
  return (
    <div>
      <br /><br />
      <div class="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-5 mx-auto">
        <div class="">
          <div class="row d-flex">
            <div class="col-lg-6">
              <div class="card1 pb-5">
                <div class="row">  </div>
                <div class="row px-3 justify-content-center mt-4 mb-5 border-line-left">  <img alt="executive2" width="" src="/assets/images/ban-image.png" /> </div>
              </div>
            </div>
            <div class="col-lg-6"><br />
              <div class="card2 card border-0 px-4 py-5">
                <div class="row px-3 mb-4">
                  <div class="line-forgot"></div> <span class="or-forgot text-center"> Verify OTP</span>
                  <div class="line-forgot"></div>
                </div>
                <Form onSubmit={handleFormSubmit}>
                  <div class="row px-3 mb-3"> <label class="mb-1">
                    <h6 class="mb-0 text-sm">username</h6>
                  </label>
                    <Input
                      type="text"
                      name="emai"
                      id="emai"
                      value={email}
                      disabled={true}
                    />
                  </div>
                  <div class="row px-3 mb-3"> <label class="mb-1">
                    <h6 class="mb-0 text-sm">OTP</h6>
                  </label>
                    <Input
                      type="text"
                      name="otp"
                      id="otp"
                      placeholder="Enter Otp Here"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>
                  <div class="row mb-3 px-3"> {email ? <button type="submit" class="btn btn-blue text-center">  Verify OTP</button> : "Invalid Request"}</div>
                </Form>
                <div class="row mb-4 px-3"> <small class="font-weight-bold">Already Register?<Link tag={Link} class="text-danger " to="/Signin"><u>Sign in</u></Link> </small> </div>
                <div class="row px-3 ">
                  <div class="line-follow"></div> <small class="or-follow text-center">Follow us</small>
                  <div class="line-follow"></div>
                </div>
                <div class="row mr-l">
                  <div class="facebook text-center mr-3">{// eslint-disable-next-line
                  } <a href={'https://www.facebook.com/eduplusnow/'} ><FacebookIcon /></a>
                  </div>
                  <div class="twitter text-center mr-3">{// eslint-disable-next-line
                  } <a href={'href="https://www.youtube.com/channel/UCtkn64AR1Qrmk2Z-o0bzzsA"'} ><YouTubeIcon /></a>
                  </div>
                  <div class="linkedin text-center mr-3">{// eslint-disable-next-line
                  } <a href={'https://www.linkedin.com/company/edu-plus-now/'} >
                      <LinkedInIcon /></a>
                  </div>
                  <div class="insta text-center mr-3">{// eslint-disable-next-line
                  } <a href={'https://www.instagram.com/eduplusnow/'} >
                      <InstagramIcon /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Test4;
